import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import redirectPageReducer from "./redirectPageSlice";
import searchFilterReducer from "./searchFilterSlice";
import searchResultPageReducer from "./searchResultPageSlice";
import userMetaDataReducer from "./userMetaDataSlice";

const store = configureStore({
  reducer: {
    searchFilter: searchFilterReducer,
    searchResultPage: searchResultPageReducer,
    userMetaData: userMetaDataReducer,
    redirectPage: redirectPageReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
